<h2 data-qa="aktiveDf-headline">Aktive Datenabfrage</h2>
@if (isAktiveDatenabfragePresent()) {
  <div>
    <mat-card data-qa="datenabfrageCard">
      <mat-card-header>
        <mat-card-subtitle>Bezeichnung der Datenabfrage</mat-card-subtitle>
        <mat-card-title data-qa="datenabfrageCard-bezeichnung-text">{{datenabfrage.bezeichnung}}</mat-card-title>
      </mat-card-header>
      <tnb-datenabfrage-card-content [aufteilungsSchluessels]="aufteilungsSchluessels" [datenabfrage]="datenabfrage">
      </tnb-datenabfrage-card-content>
      <mat-card-actions>
        @if (isWestnetzAdmin) {
          <button (click)="deleteAktiveDatenabfrage()"
                  [disabled]="datenabfrage === null"
                  class="actionbutton button-warn"
                  data-qa="button-delete-aktiveDatenabfrage"
                  id="deleteAktiveDatenabfrageButton"
                  matButton="filled"
                  aria-label="Aktive Datenabfrage löschen"
            >
            <mat-icon svgIcon="innogy_picto_bin_c-check"></mat-icon>
            Löschen
          </button>
        }
        @if (isWestnetzAdmin) {
          <button (click)="archiviereAktiveDatenabfrage()"
                  [disabled]="datenabfrage === null"
                  class="actionbutton"
                  data-qa="button-archive-aktiveDatenabfrage"
                  id="archiviereAktiveDatenabfrageButton"
                  matButton="outlined"
                  aria-label="Datenabfrage archivieren"
            >
            <mat-icon>archive</mat-icon>
            Archivieren
          </button>
        }
        @if (isWestnetzAdmin) {
          <button (click)="csvExportAktiveDatenfrage(datenabfrage.id)"
            [disabled]="datenabfrage === null"
            class="actionbutton"
            data-qa="button-csvexport-aktiveDatenabfrage"
            id="csvExportAktiveDatenfrage"
            matButton="outlined">
            <mat-icon>file_download</mat-icon>
            CSV exportieren
          </button>
        }
        @if (isStadtwerk) {
          <button (click)="submitAts()"
            [disabled]="shouldDisplayATSSubmitButton()"
            class="actionbutton"
            data-qa="button-archive-aktiveDatenabfrage"
            id="addAtsToAktiveDatenabfrageButton"
            matButton="filled"
            >
            <mat-icon>add</mat-icon>
            Aufteilungsschlüssel eintragen
          </button>
        }
      </mat-card-actions>
    </mat-card>
  </div>
} @else {
  <p data-qa="aktive-datenabfrage-notexist-hint">Aktuell gibt es keine aktive Datenabfrage</p>
  @if (isWestnetzAdmin) {
    <button (click)="createAktiveDatenabfrage()"
      [disabled]="this.datenabfrage !== null && this.datenabfrage?.id !== null"
      data-qa="button-create-aktiveDatenabfrage"
      id="createAktiveDatenabfrageButton"
      matButton="filled"
    >
      <mat-icon>add</mat-icon>
      Neue Datenabfrage
    </button>
  }
}
